module.exports = __webpack_public_path__ + "static/media/withoutPromos.06862151.svg";